import { render, staticRenderFns } from "./workRecordsActivitySummaryPage.vue?vue&type=template&id=9961a278&"
import script from "./workRecordsActivitySummaryPage.vue?vue&type=script&lang=ts&"
export * from "./workRecordsActivitySummaryPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports